import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { siQuoteUrls } from '../../../environments/environment';
import { GetUserPreferencesRequest, GetUserPreferencesResponse, SetUserPreferencesRequest } from "../../models/dtos";
import { BaseHttpService } from "./base-http.service";
import { UserProfileService } from "../common/user-profile.service";


@Injectable({
  providedIn: 'root'
})
export class PreferenceApiService {

  constructor(private readonly baseHttp: BaseHttpService,
     private readonly userProfileService: UserProfileService
  ) { }

  getPreference(requestBody: GetUserPreferencesRequest): Observable<GetUserPreferencesResponse> {
    requestBody.userId = this.userProfileService.userInfo?.gid ?? "";
    return this.baseHttp.post<GetUserPreferencesResponse>(`${siQuoteUrls.userPreferences}/GetUserPreferences`, requestBody);
  }

  setPreference(requestBody: SetUserPreferencesRequest): Observable<boolean> {
    requestBody.userId = this.userProfileService.userInfo?.gid ?? "";
    return this.baseHttp.post<boolean>(`${siQuoteUrls.userPreferences}/SetUserPreferences`, requestBody);
  }

}